import { render, staticRenderFns } from "./modal-items.vue?vue&type=template&id=24796816"
import script from "./modal-items.vue?vue&type=script&lang=js"
export * from "./modal-items.vue?vue&type=script&lang=js"
import style0 from "./modal-items.vue?vue&type=style&index=0&id=24796816&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports